import { useEffect, useState } from "react";
import { Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import { StorageFile } from "../model/StorageFile";
import { getStorageFiles, STORAGE_FOLDERS } from "../service/StorageService";
import { StorageFileDataGrid } from "../components/StorageFileDataGrid";

export default function StoragePage() {
  const [tab, setTab] = useState(0);
  const [files, setFiles] = useState<StorageFile[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadFiles = () => {
    setLoading(true);
    setError(null);
    getStorageFiles(STORAGE_FOLDERS[tab].path)
      .then((data) => setFiles(data))
      .catch((err) => {
        console.error(err);
        setError("Impossible de charger les fichiers.");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadFiles();
  }, [tab]);

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}
      >
        {STORAGE_FOLDERS.map((f) => (
          <Tab key={f.path} label={f.label} />
        ))}
      </Tabs>

      <Box sx={{ p: 2 }}>
        {loading && (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Typography color="error" mt={2}>
            {error}
          </Typography>
        )}
        {!loading && !error && (
          <StorageFileDataGrid files={files} onDeleted={loadFiles} />
        )}
      </Box>
    </Box>
  );
}
